import React from "react";

// action
import { contactUs } from "../store/user/action";
// redux
import { connect } from "react-redux";

// validation
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";

const ContactUs = (props) => {

    // form validation rules
    const validationSchema = Yup.object().shape({
        name: Yup.string().trim().required("Name is Required!"),
        subject: Yup.string().trim().required("Subject is Required!"),
        message: Yup.string().trim().required("Message is Required!"),
        email: Yup.string().trim().required("Email is Required!").matches(/^[a-z0-9]+@[a-z]+\.[a-z]{2,3}$/, "Invalid Email!"),
    });

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm({ mode: "onChange", resolver: yupResolver(validationSchema) });

    const onSubmit = (values) => {
        props.contactUs(values);
        reset();
    };

    return (
        <section id="contact" className="contact">
            <div className="container">

                <div className="section-title">
                    <h2><span>Contact</span> Us</h2>
                </div>
            </div>

            <div className="map">
                <iframe style={{ border: 0, width: "100%", height: 350 }} src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12097.433213460943!2d-74.0062269!3d40.7101282!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xb89d1fe6bc499443!2sDowntown+Conference+Center!5e0!3m2!1smk!2sbg!4v1539943755621" frameborder="0" allowfullscreen=""></iframe>
            </div>

            <div className="container mt-5">

                <div className="info-wrap">
                    <div className="row">
                        <div className="col-lg-3 col-md-6 info">
                            <i className="fas fa-map-marker-alt"></i>
                            <h4>Location:</h4>
                            <p>A108 Adam Street<br />New York, NY 535022</p>
                        </div>

                        <div className="col-lg-3 col-md-6 info mt-4 mt-lg-0">
                            <i className="far fa-clock"></i>
                            <h4>Open Hours:</h4>
                            <p>Monday-Saturday:<br />11:00 AM - 2300 PM</p>
                        </div>

                        <div className="col-lg-3 col-md-6 info mt-4 mt-lg-0">
                            <i className="far fa-envelope"></i>
                            <h4>Email:</h4>
                            <p><a href='mailto:info@example.com?subject=subject&cc=cc@example.com'>info@example.com<br />contact@example.com</a></p>
                        </div>

                        <div className="col-lg-3 col-md-6 info mt-4 mt-lg-0">
                            <i className="fas fa-phone-alt"></i>
                            <h4>Call:</h4>
                            <p>+1 5589 55488 51<br />+1 5589 22475 14</p>
                        </div>
                    </div>
                </div>

                <form onSubmit={handleSubmit(onSubmit)} autoComplete="off" className="php-email-form">
                    <div className="row">
                        <div className="col-md-6 form-group">
                            <input type="text" name="name" className="form-control" id="name" placeholder="Your Name" required {...register("name")} />
                            <div className="invalid-feedback">{errors.name?.name}</div>
                        </div>
                        <div className="col-md-6 form-group mt-3 mt-md-0">
                            <input type="email" className="form-control" name="email" id="email" placeholder="Your Email" required {...register("email")} />
                            <div className="invalid-feedback">{errors.name?.email}</div>
                        </div>
                    </div>
                    <div className="form-group mt-3">
                        <input type="text" className="form-control" name="subject" id="subject" placeholder="Subject" required {...register("subject")} />
                        <div className="invalid-feedback">{errors.name?.subject}</div>
                    </div>
                    <div className="form-group mt-3">
                        <textarea className="form-control" name="message" rows="5" placeholder="Message" required {...register("message")}></textarea>
                        <div className="invalid-feedback">{errors.name?.message}</div>
                    </div>
                    <div className="text-center"><button type="submit">Send Message</button></div>                </form>

            </div>
        </section>
    );
};

export default connect(null, { contactUs })(ContactUs);
